import React, { useEffect } from "react";
const Policies = () => {
  useEffect(() => {
    document.title = "Snilink - Policies";
  }, []);
  const date = "May 2023";
  return (
    <>
      <section className="section first-section | md:pt-[155px] md:pb-94px md:px-30px | pt-[135px] pb-64px px-20px ">
        <div className="section-container policies | max-w-[1000px] flex flex-col m-auto | md:gap-32px gap-20px">
          <div className="policies-row flex flex-col md:gap-16px gap-10px">
            <h1 className="headline | font-semibold m-0  text-3xl text-primary-900 | md:text-5xl">
              Privacy Policy
            </h1>
            <h2 className="text-xl text-primary-900 m-0 font-semibold">
              Last updated: {date}
            </h2>
            <p className="m-0 text-accent-500">
              JADA Mohamed operates SNILINK. This page informs you of our
              policies regarding the collection, use, and disclosure of Personal
              Information we receive from users of the Site.
            </p>
            <p className="m-0 text-accent-500">
              We use your Personal Information only for providing and improving
              the Site. By using the Site, you agree to the collection and use
              of information in accordance with this policy.
            </p>
          </div>
          <div className="policies-row flex flex-col md:gap-16px gap-10px">
            <h1 className="text-xl text-primary-900 m-0 font-semibold ">
              Information Collection and Use
            </h1>
            <p className="m-0 text-accent-500">
              While using our Site, we may ask you to provide us with certain
              personally identifiable information that can be used to contact or
              identify you. Personally identifiable information may include, but
              is not limited to your name, email address, and phone number
              ("Personal Information").
            </p>
          </div>
          <div className="policies-row flex flex-col md:gap-16px gap-10px">
            <h1 className="text-xl text-primary-900 m-0 font-semibold ">
              Log Data
            </h1>
            <p className="m-0 text-accent-500">
              Like many site operators, we collect information that your browser
              sends whenever you visit our Site ("Log Data"). This Log Data may
              include information such as your computer's Internet Protocol
              ("IP") address, browser type, browser version, the pages of our
              Site that you visit, the time and date of your visit, the time
              spent on those pages, and other statistics.
            </p>
          </div>
          <div className="policies-row flex flex-col md:gap-16px gap-10px">
            <h1 className="text-xl text-primary-900 m-0 font-semibold ">
              Cookies
            </h1>
            <p className="m-0 text-accent-500">
              Cookies are files with small amounts of data, which may include an
              anonymous unique identifier. Cookies are sent to your browser from
              a web site and stored on your computer's hard drive.
            </p>
            <p className="m-0 text-accent-500">
              Like many sites, we use "cookies" to collect information. You can
              instruct your browser to refuse all cookies or to indicate when a
              cookie is being sent. However, if you do not accept cookies, you
              may not be able to use some portions of our Site.
            </p>
          </div>
          <div className="policies-row flex flex-col md:gap-16px gap-10px">
            <h1 className="text-xl text-primary-900 m-0 font-semibold ">
              Security
            </h1>
            <p className="m-0 text-accent-500">
              The security of your Personal Information is important to us, but
              remember that no method of transmission over the Internet, or
              method of electronic storage, is 100% secure. While we strive to
              use commercially acceptable means to protect your Personal
              Information, we cannot guarantee its absolute security.
            </p>
          </div>
          <div className="policies-row flex flex-col md:gap-16px gap-10px">
            <h1 className="text-xl text-primary-900 m-0 font-semibold ">
              Changes to This Privacy Policy
            </h1>
            <p className="m-0 text-accent-500">
              This Privacy Policy is effective as of May 2023 and will remain in
              effect except with respect to any changes in its provisions in the
              future, which will be in effect immediately after being posted on
              this page.
            </p>
            <p className="m-0 text-accent-500">
              We reserve the right to update or change our Privacy Policy at any
              time and you should check this Privacy Policy periodically. Your
              continued use of the Service after we post any modifications to
              the Privacy Policy on this page will constitute your
              acknowledgment of the modifications and your consent to abide and
              be bound by the modified Privacy Policy.
            </p>
          </div>
          <div className="policies-row flex flex-col md:gap-16px gap-10px">
            <h1 className="text-xl text-primary-900 m-0 font-semibold ">
              Contact Us
            </h1>
            <p className="m-0 text-accent-500">
              If you have any questions about this Privacy Policy, please{" "}
              <a
                className="text-primary-500 font-semibold"
                href="mailto:jadamohameed@gmail.com"
                target="blank"
              >
                contact us
              </a>
              .
            </p>
          </div>
        </div>
      </section>
    </>
  );
};
export default Policies;
